import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\Editor\GetNewDocumentEditorController::__invoke
* @see app/Http/Controllers/Document/Editor/GetNewDocumentEditorController.php
* @route '/api/editor/{type}'
*/
const GetNewDocumentEditorController = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetNewDocumentEditorController.url(args, options),
    method: 'get',
})

GetNewDocumentEditorController.definition = {
    methods: ["get","head"],
    url: '/api/editor/{type}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Document\Editor\GetNewDocumentEditorController::__invoke
* @see app/Http/Controllers/Document/Editor/GetNewDocumentEditorController.php
* @route '/api/editor/{type}'
*/
GetNewDocumentEditorController.url = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { type: args }
    }

    if (Array.isArray(args)) {
        args = {
            type: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
    }

    return GetNewDocumentEditorController.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\Editor\GetNewDocumentEditorController::__invoke
* @see app/Http/Controllers/Document/Editor/GetNewDocumentEditorController.php
* @route '/api/editor/{type}'
*/
GetNewDocumentEditorController.get = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetNewDocumentEditorController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Document\Editor\GetNewDocumentEditorController::__invoke
* @see app/Http/Controllers/Document/Editor/GetNewDocumentEditorController.php
* @route '/api/editor/{type}'
*/
GetNewDocumentEditorController.head = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetNewDocumentEditorController.url(args, options),
    method: 'head',
})

export default GetNewDocumentEditorController